import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, renderSlot as _renderSlot, unref as _unref, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6093494a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  style: {
    "color": "red"
  }
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 2
};
const _hoisted_4 = {
  key: 3
};
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
  key: 5
};
const _hoisted_7 = {
  key: 6
};
import _ from 'lodash';
import { odataDateToString } from '@/utils/odataUtilCommon';
import { priceFormat } from '@/utils/common';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'CommonTableColumn',
  props: {
    schema: {
      type: Object,
      required: true
    },
    tableUiSchema: {
      type: Object,
      required: true
    },
    labelMode: {
      type: Boolean,
      required: false,
      default: false
    },
    rules: {
      type: Object,
      required: true
    },
    labelWidth: {
      type: String,
      required: false,
      default: ''
    },
    column: {
      required: false,
      type: [String, Object]
    },
    triArray: {
      type: Array,
      required: false
    }
  },
  setup(__props) {
    const prop = __props;
    const domainFormatValue = (value, filed) => {
      if (value === undefined || !prop.schema || !prop.schema.properties) {
        return '';
      }
      /* if (_.isEmpty(value) || !prop.schema || !prop.schema.properties) {
        return ''
      } */
      const vals = Array.isArray(value) ? value : [value];
      const listObj = prop.schema.properties[filed].oneOf;
      const texts = vals.map(val => {
        let text = '';
        const res = listObj.filter(e => e.const === val);
        if (res && res.length > 0) {
          text = res[0].title;
        }
        return text;
      });
      return texts.length === 1 ? texts[0] : texts.join(', ');
    };
    const valueInput = (row, filed, precision) => {
      // 防止删除为空 或不为数字
      if (!row[filed] || isNaN(row[filed])) {
        const zearo = 0;
        row[filed] = zearo.toFixed(precision) + '';
      }
      if (row[filed].split('.').length > 1 && row[filed].split('.')[1].length > precision) {
        const temp = parseInt(10 + new Array(precision).join('0'));
        row[filed] = Math.floor(row[filed] * temp) / temp + '';
      }
    };
    const valueInput2 = (row, filed, precision) => {
      if (!row[filed] || isNaN(row[filed])) {
        row[filed] = '';
      }
      if (row[filed].split('.').length > 1 && row[filed].split('.')[1].length > precision) {
        const temp = parseInt(10 + new Array(precision).join('0'));
        row[filed] = Math.floor(row[filed] * temp) / temp + '';
      }
    };
    const valueToFixed = (row, filed, precision) => {
      // 防止删除为空 或不为数字
      if (!row[filed] || isNaN(row[filed])) {
        const zearo = 0;
        row[filed] = zearo.toFixed(precision) + '';
      }
      row[filed] = parseFloat(row[filed]).toFixed(precision) + '';
    };
    const commonDateFormatter = value => {
      if (_.isEmpty(value)) {
        return value;
      }
      return odataDateToString(value);
    };
    const showOverflowTooltip = item => {
      if (prop.tableUiSchema[item] && prop.tableUiSchema[item].slot) {
        return false;
      }
      if (prop.labelMode) {
        return true;
      } else if (prop.schema.properties && prop.schema.properties[item] && prop.schema.properties[item].creatable === false) {
        return true;
      }
      return false;
    };
    const minWidth = item => {
      if (prop.tableUiSchema[item] && prop.tableUiSchema[item].width) {
        return prop.tableUiSchema[item].width;
      } else if (typeof item === 'object' && prop.tableUiSchema[item.key] && prop.tableUiSchema[item.key].width) {
        return prop.tableUiSchema[item.key].width;
      }
      return prop.labelWidth;
    };
    /**
     * 用于child的三角的显示位置
     * @param column
     */
    const handleShowTri = column => {
      if (prop.triArray && prop.triArray.length > 0 && prop.triArray.indexOf(column) > -1) {
        return '';
      } else {
        return undefined;
      }
    };
    const eventBlur = (item, row, index) => {
      if (prop.tableUiSchema[item] && prop.tableUiSchema[item]['event:blur']) {
        prop.tableUiSchema[item]['event:blur'](row, index);
      }
    };
    const getOneOf = computed(() => {
      return (row, column) => {
        let result = prop.schema.properties[column].oneOf;
        if (column === 'YwType') {
          if (row.SupSrvPro === undefined || row.SupSrvPro === '') {} else if (row.SupSrvPro === 'I01') {
            result = result.filter(item => item.const == '04');
          } else {
            result = result.filter(item => item.const != '04');
          }
        }
        return result;
      };
    });
    return (_ctx, _cache) => {
      const _component_CommonTableColumn = _resolveComponent("CommonTableColumn", true);
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_InfoFilled = _resolveComponent("InfoFilled");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_input_number = _resolveComponent("el-input-number");
      const _component_el_date_picker = _resolveComponent("el-date-picker");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      return __props.column && typeof __props.column === 'object' && __props.column.children ? (_openBlock(), _createBlock(_component_el_table_column, {
        key: 0,
        "show-overflow-tooltip": showOverflowTooltip(__props.column.prop),
        prop: __props.column.prop,
        fixed: __props.tableUiSchema[__props.column.prop] && __props.tableUiSchema[__props.column.prop].fixed ? __props.tableUiSchema[__props.column.prop].fixed : false,
        "header-align": "center",
        align: __props.tableUiSchema[__props.column.prop] && __props.tableUiSchema[__props.column.prop].align ? __props.tableUiSchema[__props.column.prop].align : 'center',
        "min-width": minWidth(__props.column.prop),
        label: __props.schema.properties && __props.schema.properties[__props.column.prop] ? _ctx.$t(__props.schema.properties[__props.column.prop].title) : '',
        style: {
          "border": "1px solid red"
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.column.children, (item, index) => {
          return _openBlock(), _createBlock(_component_CommonTableColumn, {
            key: index,
            column: item.children === undefined ? item : item.children && item.children.length > 0 ? item : item.prop,
            schema: __props.schema,
            tableUiSchema: __props.tableUiSchema,
            labelMode: __props.labelMode,
            rules: __props.rules,
            labelWidth: __props.labelWidth
          }, null, 8, ["column", "schema", "tableUiSchema", "labelMode", "rules", "labelWidth"]);
        }), 128))]),
        _: 1
      }, 8, ["show-overflow-tooltip", "prop", "fixed", "align", "min-width", "label"])) : __props.column && typeof __props.column === 'object' ? (_openBlock(), _createBlock(_component_el_table_column, {
        key: 1,
        "show-overflow-tooltip": showOverflowTooltip(__props.column),
        fixed: __props.column.fixed,
        "header-align": "center",
        align: "center",
        width: minWidth(__props.column)
      }, {
        header: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t(__props.column.title)), 1)]),
        default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.$index + 1), 1)]),
        _: 1
      }, 8, ["show-overflow-tooltip", "fixed", "width"])) : __props.column && typeof __props.column === 'string' ? (_openBlock(), _createBlock(_component_el_table_column, {
        key: 2,
        "show-overflow-tooltip": showOverflowTooltip(__props.column),
        prop: __props.column,
        fixed: __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column].fixed ? __props.tableUiSchema[__props.column].fixed : false,
        "header-align": "center",
        align: __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column].align ? __props.tableUiSchema[__props.column].align : 'center',
        "min-width": minWidth(__props.column),
        label: __props.schema.properties && __props.schema.properties[__props.column] ? _ctx.$t(__props.schema.properties[__props.column].title) : '',
        type: handleShowTri(__props.column)
      }, _createSlots({
        header: _withCtx(() => [!__props.labelMode && __props.rules && __props.rules[__props.column] && __props.rules[__props.column].filter(ob => ob.required).length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_1, "*")) : _createCommentVNode("", true), _createElementVNode("span", null, [_createTextVNode(_toDisplayString(__props.schema.properties && __props.schema.properties[__props.column] ? _ctx.$t(__props.schema.properties[__props.column].title) : '') + " ", 1), __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column]['tip-content'] ? (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 0,
          class: "box-item",
          effect: "dark",
          content: __props.tableUiSchema[__props.column]['tip-content'],
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            color: "#EF890C"
          }, {
            default: _withCtx(() => [_createVNode(_component_InfoFilled)]),
            _: 1
          })]),
          _: 1
        }, 8, ["content"])) : _createCommentVNode("", true)])]),
        _: 2
      }, [__props.labelMode ? {
        name: "default",
        fn: _withCtx(scope => [__props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column].slot ? _renderSlot(_ctx.$slots, __props.column, {
          key: 0,
          row: scope.row,
          column: scope.column,
          index: scope.$index
        }) : __props.schema.properties && __props.schema.properties[__props.column] && (__props.schema.properties[__props.column].anyOf || __props.schema.properties[__props.column].oneOf) ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t(domainFormatValue(scope.row[__props.column], __props.column))), 1)) : __props.schema.properties && __props.schema.properties[__props.column] && __props.schema.properties[__props.column].format === 'date' ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(commonDateFormatter(scope.row[__props.column])), 1)) : __props.schema.properties && __props.schema.properties[__props.column] && __props.schema.properties[__props.column].format === 'price' ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(priceFormat)(scope.row[__props.column])), 1)) : __props.schema.properties && __props.schema.properties[__props.column] && __props.schema.properties[__props.column].format === 'html' ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          innerHTML: scope.row[__props.column]
        }, null, 8, _hoisted_5)) : __props.schema.properties && __props.schema.properties[__props.column] && __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column].link ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_el_link, {
          underline: false,
          type: "primary",
          onClick: $event => __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column]['event:click'] ? __props.tableUiSchema[__props.column]['event:click'](scope.row) : null
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(scope.row[__props.column]), 1)]),
          _: 2
        }, 1032, ["onClick"])])) : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(scope.row[__props.column]), 1))]),
        key: "0"
      } : !__props.labelMode ? {
        name: "default",
        fn: _withCtx(scope => [__props.schema.properties && __props.schema.properties[__props.column] && __props.schema.properties[__props.column].creatable === false ? (_openBlock(), _createElementBlock("span", {
          key: 0
        }, [__props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column].slot ? _renderSlot(_ctx.$slots, __props.column, {
          key: 0,
          row: scope.row,
          column: scope.column,
          index: scope.$index,
          form: scope.row
        }) : __props.schema.properties && __props.schema.properties[__props.column] && (__props.schema.properties[__props.column].anyOf || __props.schema.properties[__props.column].oneOf) ? (_openBlock(), _createElementBlock("span", {
          key: 1
        }, _toDisplayString(_ctx.$t(domainFormatValue(scope.row[__props.column], __props.column))), 1)) : __props.schema.properties && __props.schema.properties[__props.column].format === 'date' ? (_openBlock(), _createElementBlock("span", {
          key: 2
        }, _toDisplayString(commonDateFormatter(scope.row[__props.column])), 1)) : __props.schema.properties && __props.schema.properties[__props.column] && __props.schema.properties[__props.column].format === 'price' ? (_openBlock(), _createElementBlock("span", {
          key: 3
        }, _toDisplayString(_unref(priceFormat)(scope.row[__props.column])), 1)) : __props.schema.properties && __props.schema.properties[__props.column] && __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column].link ? (_openBlock(), _createElementBlock("span", {
          key: 4
        }, [_createVNode(_component_el_link, {
          underline: false,
          type: "primary",
          onClick: $event => __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column]['event:click'] ? __props.tableUiSchema[__props.column]['event:click'](scope.row) : null
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t(scope.row[__props.column])), 1)]),
          _: 2
        }, 1032, ["onClick"])])) : (_openBlock(), _createElementBlock("span", {
          key: 5
        }, _toDisplayString(_ctx.$t(scope.row[__props.column])), 1))])) : (_openBlock(), _createBlock(_component_el_form_item, {
          prop: scope.$index + '.' + __props.column,
          key: _ctx.index + __props.column + '-formKey',
          rules: __props.rules && (!__props.tableUiSchema[__props.column] || !__props.tableUiSchema[__props.column]['ui:rule'] || __props.tableUiSchema[__props.column]['ui:rule'](scope.row)) ? __props.rules[__props.column] : {}
        }, {
          default: _withCtx(() => [__props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column].slot ? _renderSlot(_ctx.$slots, __props.column, {
            key: 0,
            row: scope.row,
            column: scope.column,
            index: scope.$index,
            form: scope.row
          }) : __props.schema.properties && __props.schema.properties[__props.column] && __props.schema.properties[__props.column].oneOf ? (_openBlock(), _createBlock(_component_el_select, {
            key: 1,
            modelValue: scope.row[__props.column],
            "onUpdate:modelValue": $event => scope.row[__props.column] = $event,
            class: "m-2",
            clearable: "",
            filterable: "",
            multiple: __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column]['multiple'],
            "collapse-tags": true,
            style: {
              "width": "100%"
            },
            onChange: $event => __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column]['event:change'] ? __props.tableUiSchema[__props.column]['event:change'](scope.row) : null,
            disabled: __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column]['ui:disabled'] ? typeof __props.tableUiSchema[__props.column]['ui:disabled'] === 'function' ? __props.tableUiSchema[__props.column]['ui:disabled'](scope.row) : __props.tableUiSchema[__props.column]['ui:disabled'] : false,
            placeholder: _ctx.$t(__props.schema.properties[__props.column].quickinfo) || (__props.tableUiSchema[__props.column]?.placeholder ? _ctx.$t(__props.tableUiSchema[__props.column].placeholder) : _ctx.$t('msg-select-placeholder'))
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getOneOf.value(scope.row, __props.column), option => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: option.const,
                label: _ctx.$t(option.title),
                value: option.const
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 2
          }, 1032, ["modelValue", "onUpdate:modelValue", "multiple", "onChange", "disabled", "placeholder"])) : __props.schema.properties && __props.schema.properties[__props.column].type && __props.schema.properties[__props.column].type === 'number' ? (_openBlock(), _createBlock(_component_el_input_number, {
            key: 2,
            controls: false,
            min: __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column].min ? __props.tableUiSchema[__props.column].min : -99999,
            modelValue: scope.row[__props.column],
            "onUpdate:modelValue": $event => scope.row[__props.column] = $event,
            style: {
              "width": "100%"
            },
            precision: __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column].precision ? __props.tableUiSchema[__props.column].precision : '0',
            "controls-position": "right",
            maxlength: __props.tableUiSchema[__props.column]?.maxlength || '',
            "show-word-limit": __props.tableUiSchema[__props.column]?.showWordLimit || false,
            placeholder: __props.tableUiSchema[__props.column]?.placeholder ? _ctx.$t(__props.tableUiSchema[__props.column].placeholder) : '',
            onChange: $event => __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column]['event:change'] ? __props.tableUiSchema[__props.column]['event:change'](scope.row) : null,
            disabled: __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column]['ui:disabled'] ? typeof __props.tableUiSchema[__props.column]['ui:disabled'] === 'function' ? __props.tableUiSchema[__props.column]['ui:disabled'](scope.row) : __props.tableUiSchema[__props.column]['ui:disabled'] : false
          }, null, 8, ["min", "modelValue", "onUpdate:modelValue", "precision", "maxlength", "show-word-limit", "placeholder", "onChange", "disabled"])) : __props.schema.properties && (__props.schema.properties[__props.column].type === 'date' || __props.schema.properties[__props.column].format === 'date') ? (_openBlock(), _createBlock(_component_el_date_picker, {
            key: 3,
            modelValue: scope.row[__props.column],
            "onUpdate:modelValue": $event => scope.row[__props.column] = $event,
            type: "date",
            "value-format": "YYYY-MM-DD",
            style: {
              "width": "100%"
            },
            placeholder: __props.tableUiSchema[__props.column]?.placeholder ? _ctx.$t(__props.tableUiSchema[__props.column].placeholder) : _ctx.$t('msg-date-placeholder'),
            onChange: $event => __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column]['event:change'] ? __props.tableUiSchema[__props.column]['event:change'](scope.row) : null,
            disabled: __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column]['ui:disabled'] ? typeof __props.tableUiSchema[__props.column]['ui:disabled'] === 'function' ? __props.tableUiSchema[__props.column]['ui:disabled'](scope.row) : __props.tableUiSchema[__props.column]['ui:disabled'] : false
          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "onChange", "disabled"])) : __props.schema.properties && __props.schema.properties[__props.column].type === 'string' && __props.tableUiSchema[__props.column] && (__props.tableUiSchema[__props.column].precision || __props.tableUiSchema[__props.column].precision === 0) ? (_openBlock(), _createBlock(_component_el_input, {
            key: 4,
            onInput: $event => valueInput(scope.row, __props.column, __props.tableUiSchema[__props.column].precision),
            onBlur: $event => {
              valueToFixed(scope.row, __props.column, __props.tableUiSchema[__props.column].precision);
              eventBlur(__props.column, scope.row, scope.$index);
            },
            modelValue: scope.row[__props.column],
            "onUpdate:modelValue": $event => scope.row[__props.column] = $event,
            maxlength: __props.tableUiSchema[__props.column]?.maxlength || '',
            "show-word-limit": __props.tableUiSchema[__props.column]?.showWordLimit || false,
            placeholder: __props.tableUiSchema[__props.column]?.placeholder ? _ctx.$t(__props.tableUiSchema[__props.column].placeholder) : '',
            disabled: __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column]['ui:disabled'] ? typeof __props.tableUiSchema[__props.column]['ui:disabled'] === 'function' ? __props.tableUiSchema[__props.column]['ui:disabled'](scope.row) : __props.tableUiSchema[__props.column]['ui:disabled'] : false
          }, null, 8, ["onInput", "onBlur", "modelValue", "onUpdate:modelValue", "maxlength", "show-word-limit", "placeholder", "disabled"])) : __props.schema.properties && __props.schema.properties[__props.column].type === 'string' && __props.tableUiSchema[__props.column] && (__props.tableUiSchema[__props.column].decimal || __props.tableUiSchema[__props.column].decimal === 0) ? (_openBlock(), _createBlock(_component_el_input, {
            key: 5,
            onInput: $event => valueInput2(scope.row, __props.column, __props.tableUiSchema[__props.column].decimal),
            onBlur: $event => {
              valueToFixed(scope.row, __props.column, __props.tableUiSchema[__props.column].decimal);
              eventBlur(__props.column, scope.row, scope.$index);
            },
            modelValue: scope.row[__props.column],
            "onUpdate:modelValue": $event => scope.row[__props.column] = $event,
            maxlength: __props.tableUiSchema[__props.column]?.maxlength || '',
            "show-word-limit": __props.tableUiSchema[__props.column]?.showWordLimit || false,
            placeholder: __props.tableUiSchema[__props.column]?.placeholder ? _ctx.$t(__props.tableUiSchema[__props.column].placeholder) : '',
            disabled: __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column]['ui:disabled'] ? typeof __props.tableUiSchema[__props.column]['ui:disabled'] === 'function' ? __props.tableUiSchema[__props.column]['ui:disabled'](scope.row) : __props.tableUiSchema[__props.column]['ui:disabled'] : false
          }, null, 8, ["onInput", "onBlur", "modelValue", "onUpdate:modelValue", "maxlength", "show-word-limit", "placeholder", "disabled"])) : (_openBlock(), _createBlock(_component_el_input, {
            key: 6,
            disabled: __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column]['ui:disabled'] ? typeof __props.tableUiSchema[__props.column]['ui:disabled'] === 'function' ? __props.tableUiSchema[__props.column]['ui:disabled'](scope.row) : __props.tableUiSchema[__props.column]['ui:disabled'] : false,
            maxlength: __props.tableUiSchema[__props.column]?.maxlength || '',
            "show-word-limit": __props.tableUiSchema[__props.column]?.showWordLimit || false,
            placeholder: __props.tableUiSchema[__props.column]?.placeholder ? _ctx.$t(__props.tableUiSchema[__props.column].placeholder) : '',
            modelValue: scope.row[__props.column],
            "onUpdate:modelValue": $event => scope.row[__props.column] = $event,
            onClick: $event => __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column]['event:click'] ? __props.tableUiSchema[__props.column]['event:click'](scope.row) : null,
            onChange: $event => __props.tableUiSchema[__props.column] && __props.tableUiSchema[__props.column]['event:change'] ? __props.tableUiSchema[__props.column]['event:change'](scope.row) : null,
            clearable: ""
          }, null, 8, ["disabled", "maxlength", "show-word-limit", "placeholder", "modelValue", "onUpdate:modelValue", "onClick", "onChange"]))]),
          _: 2
        }, 1032, ["prop", "rules"]))]),
        key: "1"
      } : undefined]), 1032, ["show-overflow-tooltip", "prop", "fixed", "align", "min-width", "label", "type"])) : _createCommentVNode("", true);
    };
  }
});